var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new_user" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { attrs: { id: "content" } },
          [
            _c("dd-sitemap", {
              attrs: { pageKey: _vm.pageKey, pageList: _vm.pageList }
            }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm.isNewCorp && !_vm.isInviteUser
              ? _c(
                  "section",
                  [
                    _vm.isPrivateUser
                      ? _c("h3", [_vm._v("会員連絡先")])
                      : _c("h3", [_vm._v("企業情報")]),
                    _vm._v(" "),
                    _c("dd-corp-confirm", {
                      attrs: {
                        corpForm: _vm.corpForm,
                        isPrivateUser: _vm.isPrivateUser,
                        isEdit: false
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "section",
              [
                _c("h3", [_vm._v("ユーザー情報")]),
                _vm._v(" "),
                _c("dd-user-confirm", {
                  attrs: {
                    userForm: _vm.userForm,
                    isPrivateUser: _vm.isPrivateUser,
                    isEdit: false
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "control_btn_area" }, [
              _c(
                "div",
                {
                  staticClass: "detail_btn2",
                  on: {
                    click: function($event) {
                      _vm.reEdit()
                    }
                  }
                },
                [_vm._v("内容を修正する")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "detail_btn",
                  on: {
                    click: function($event) {
                      _vm.newUser()
                    }
                  }
                },
                [_vm._v("本会員登録へ")]
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("登録情報確認")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8641471a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8641471a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcRegistUserConfirm.vue
// module id = null
// module chunks = 